import { ApiListResponse, ApiResponse } from "@/types/api-response.model";
import { LeaveBalance, CreateLeaveDto, LeaveData } from "@/types/leave.interfaces";
import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";

@Injectable({ providedIn: 'root' })
export class LeaveService {
  private http = inject(HttpClient);
  private readonly apiUrl = `/api/leaves`;

  getLeaves(): Observable<ApiListResponse<LeaveData>> {
    return this.http.get<ApiListResponse<LeaveData>>(this.apiUrl);
  }

  getLeaveById(id: string): Observable<ApiResponse<LeaveData>> {
    return this.http.get<ApiResponse<LeaveData>>(`${this.apiUrl}/${id}`);
  }

  getLeaveBalance(employeeId: string): Observable<ApiResponse<LeaveBalance>> {
    return this.http.get<ApiResponse<LeaveBalance>>(`${this.apiUrl}/balance/${employeeId}`);
  }

  createLeave(payload: CreateLeaveDto): Observable<ApiResponse<LeaveData>> {
    return this.http.post<ApiResponse<LeaveData>>(this.apiUrl, payload);
  }

  updateLeave(id: string, payload: Partial<CreateLeaveDto>): Observable<ApiResponse<LeaveData>> {
    return this.http.patch<ApiResponse<LeaveData>>(`${this.apiUrl}/${id}`, payload);
  }

  approveLeave(id: string): Observable<ApiResponse<LeaveData>> {
    return this.http.patch<ApiResponse<LeaveData>>(`${this.apiUrl}/${id}/approve`, {});
  }

  rejectLeave(id: string): Observable<ApiResponse<LeaveData>> {
    return this.http.patch<ApiResponse<LeaveData>>(`${this.apiUrl}/${id}/reject`, {});
  }

  cancelLeave(id: string): Observable<ApiResponse<LeaveData>> {
    return this.http.patch<ApiResponse<LeaveData>>(`${this.apiUrl}/${id}/cancel`, {});
  }
}
